module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bsnmrz/tc-custom/9781649793485.jpg?1705766127335",
      "alt": "This image is the cover for the book Jockeying for Position"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jockeying for Position\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("It’s said that amazing things happen when you’re in the right place at the right time. Right place, right time was a reality one early morning as I walked down the shed row of the barn at the racetrack toward my boss, Jim. I will never forget him looking up from the newspaper and saying to me, “Well, jock, do you want to ride races?” I was so angry when he said that because in those days, women were not allowed to be jockeys. I remember thinking, "), _c('em', [_vm._v("I am as good as any guy on a horse but I can’t ride races because it is a male dominated sport")]), _vm._v(". Jim looked at me and said, “Look at this article in the paper.” Sure enough, a woman, Kathy Kusner, had applied for a jockey license.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("This would change history, my life, and the lives of many other women who wanted to pursue non-traditional careers. I am the 4")]), _c('span', {
    staticStyle: {
      "font-family": "\"Grotesque Light\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("th")]), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" woman jockey in US history to ride and win a race at a recognized track. I am also the first woman jockey to win races in Arizona and Colorado, and the first woman jockey to become a member of the male Jockey Guild. It has been over 50 years since I rode my first race. Since I’m not getting any younger, I decided it was about time that I wrote my story, because it is so unique. Hope you have as much fun reading it as I did living it.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandy Schleiffers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "16px",
      "font-family": "\"Courier New\"",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Sandy Schleiffers is one of the pioneer women jockeys of yesteryear. She is the fourth woman jockey in US history to win a thoroughbred race at a pari-mutuel track. She is also the first woman jockey to be licensed and to win a race in both Arizona and Colorado history. In addition, she is the first woman admitted to the men’s Jockey Guild. Sandy rode thoroughbred races for 7 years from 1969 to 1976. At the end of 1976, Sandy retired from racing and returned to school. She finished her bachelor’s degree, a master’s degree, and finally a PhD in 1985. She is the only jockey male or female to earn a PhD Sandy is currently retired after a successful career as a lecturer at Colorado State University where she taught for 25 years.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0